import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { BaseApi } from './base-api.service';
import { environment as ENV } from '../../environments/environment';
import { map } from 'rxjs/operators';

@Injectable()
export class ApplicantService {

  private applicantId: string;
  private baseUrl: string;
  private custId: string;
  public storeDistrict : number;
  public storeMandal : number;
  public storeVillage : number;
  public resDistrict : any= [];
  public resMandal :  any= [];
  public resVillage : any=  [];
  public resSurvey : any=  [];
  dataObj: any;
  getBaseUrl: string;

  constructor(
    private api: BaseApi,
    private http: HttpClient,
  ) {
    this.applicantId = this.getApplicantID();
    // this.coapplicantId = sessionStorage.getItem('wl-cust-applicant-id');
    this.custId = this.getCustId();
    this.baseUrl = `/applicants/${this.applicantId}`;
    // this.baseUrlCust = `/applicants/${this.applicantId}`;
    this.applicantId = this.getApplicantID(),
      this.getBaseUrl = `/applicants/${this.applicantId}/assets/bhoomi`;
  }

  getLandDetails() {
    return this.api.newGet(this.getBaseUrl);
  }

  uploadSignedConsent(fd: FormData, docType: string) {
    fd.append('applicantId', this.applicantId);
    fd.append('bureauType', '0')
    return this.api.newPost(`/users/upldCnst`, fd).pipe(map(result => {
      console.log('Document Upload Signed Consent: ', result);
      result = ENV.imageUrl + result;
      return result;
    }))
  }

  getImage(image){
    return this.api.getComplt(image).pipe(map(result=>{
      return result
    }))
  }

  getLoanAmountStrings(){
    return this.api.postResMp('/users/getUtilityData',{})
  }

  expiryLinkpost(fileName) {

    return this.api.postRes('/users/getSignedUrl', { 'fileName': fileName, 'type': 0 })
      .pipe(map(res => {
        return res;
      }));
  }

  uploadFile(formData: FormData, applicantId: string) {
    const url = `/users_upload/uploadUsersDocuments/${applicantId}`;
    return this.api.postFile(url, formData);
  }

  getFilesList(applicantId){
    const url = `/users_upload/getUsersDocumentList/${applicantId}`;
    return this.api.getComplt(url)
  }

  downloadFile(applicantId,fileName){
    const url = `/users_upload/downloadUsersDocuments/${applicantId}`;
    return this.api.postResMp(url,{fileName})
  }
  

  expiryLinkpost2(fileName) {

    return this.api.postRes('/users/getSignedUrl', { 'fileName': fileName, 'type': 1 })
      .pipe(map(res => {
        return res;
      }));
  }

  getApplicantID() {
    return sessionStorage.getItem('wl-applicant-id');
  }

  getCustId() {
    return sessionStorage.getItem('wl-custId');
  }

  getAdminID() {
    return sessionStorage.getItem('wl-admin-id');
  }

  getEverythingReport(id) {
    return this.api.newGet(`/applicants/${id}`);
  }

  getProfile() {
    return this.api.newGet(`${this.baseUrl}/profile`).pipe(map(profile => {
      console.log("profile app " + JSON.stringify(profile))
      // profile.img = (profile && profile.img) ? ENV.imageUrl.slice(0, -1) + profile.img : null;
      return profile;
    }));
  }

  getCbsStatus(){
    return this.api.postRes('/users/getCbsStatus', { 'applicantId': this.getApplicantID()})
    .pipe(map(res => {
      return res;
    }));
  }

  updateProfile(profile) {
    return this.api.put(`${this.baseUrl}/profile`, profile);
  }

  uploadProfilePic(fd: FormData) {
    fd.append('applicantId', this.applicantId);
    const file = fd.get('file');

    fd.delete('file');
    fd.set('file', file);

    console.log(fd.getAll('file'))

    return this.api.newPost(`/users/profileUpload`, fd).pipe(map(result => {
      return result;
    }));
  }

  getVerificationStatus() {
    return this.api.newGet(`/users/validation/${this.applicantId}/history`);
  }

  getEverything() {
    return this.api.newGet(this.baseUrl);
  }

  getCoApplicantData(coapp) {
    return this.api.newGet(`/applicants/` + coapp);
  }

  getReport() {
    // return this.api.newGet(`/pdf/${this.applicantId}`);pdf/getpdftestubi/61b49e1323e6183600bc0679
    // return this.api.newGet(`/pdf/getpdf/${this.custId}`);getpdftestubiv1
    // return this.api.newGet(`/pdf/getpdftestubi/${this.applicantId}`);
    return this.api.newGet(`/pdf/getpdftestubiv1/${this.applicantId}`);


  }

  getReportAdmin(id) {
    // return this.api.newGet(`/pdf/${this.applicantId}`);pdf/getpdftestubi/61b49e1323e6183600bc0679
    // return this.api.newGet(`/pdf/getpdf/${this.custId}`);getpdftestubiv1
    // return this.api.newGet(`/pdf/getpdftestubi/${this.applicantId}`);
    return this.api.newGet(`/pdf/getpdftestubiv1/${id}`);


  }


  getConsentReport() {
    // return this.api.newGet(`/pdf/${this.applicantId}`);pdf/getpdftestubi/61b49e1323e6183600bc0679
    // return this.api.newGet(`/pdf/getpdf/${this.custId}`);
    return this.api.newGet(`/pdf/getpdfconsentformubi/${this.applicantId}`);

  }

  getConsentReportAdmin(id) {
    // return this.api.newGet(`/pdf/${this.applicantId}`);pdf/getpdftestubi/61b49e1323e6183600bc0679
    // return this.api.newGet(`/pdf/getpdf/${this.custId}`);
    return this.api.newGet(`/pdf/getpdfconsentformubi/${id}`);

  }


  getAadharReport() {
    return this.api.newGet(`/aadhaar-applicants/pdf/${this.applicantId}`);
  }

  getLoans() {
    return this.api.newGet(`${this.baseUrl}/loans`);
  }

  share(share) {
    return this.api.newPost(`/pdf/shareLoanKey`, share);
  }

  uploadDocument(fd: FormData, docType: string) {
    return this.api.newPost(`/users/upload/${this.applicantId}/${docType}`, fd).pipe(map(result => {
      console.log('Document Upload Res Service: ', result);
      result = ENV.imageUrl + result;
      return result;
    }))
  }

  updateFormData(bankName, data) {
    const appData = {
      appData: data
    };

    console.log("appData " + appData);
    return this.api.newPost(`/loan-app`, { applicantId: this.applicantId, bankName: bankName, appData: data }).pipe(map(res => {
      console.log('Update Form Data : ', res);

      return res;
    }))
  }

  getFormData(bankName) {
    return this.api.newGet(`/loan-app/getAppData?applicantId=` + this.applicantId + '&bankName=' + bankName);
    // return this.api.newGet(`/loan-app/getAppData?applicantId=`+ "5ac76a235c578b12c8e55b85" + '&bankName=' + 'axis');
    // .map(res => {"5ac76a235c578b12c8e55b85"
    // console.log('Update Form Data : ', res);

    // return res;
    // })
  }

  sanitization(name) {
    const payload = { applicantId: this.getApplicantID(), name1: name }

    return this.api.sanpost('matchName', payload).pipe(map(res => {
      console.log('Match Name: ', res)
      return res;
    }))
  }

  getAutofill() {
    return this.api.newPost(`/users/autofill`, { applicantId: this.applicantId }).pipe(map(autofill => {
      console.log('Autofill Service: ', autofill);
      if (autofill.gender == 'M') { autofill.gender = 'Male' }
      else if (autofill.gender == 'F') { autofill.gender = 'Female' }
      return {
        basicAuto: {
          name: autofill.Name,
          fatherName: autofill.fatherName,
          gender: autofill.gender,
          mobileNo: autofill.ApplicantMobileNo
        },
        creditAuto: {
          firstName: autofill.panName,
          gender: autofill.gender,
          dateOfBirth: autofill.aadhaarDob,
          flatno: autofill.address && autofill.address.substring(0, 40),
          pan: autofill.panNo,
          pincode: autofill.aadhaarPinCode,
          email: autofill.email,
          city: autofill.city,
          // state: autofill.state,
        }
      }
    }))
  }

  getCreditHistory() {
    return this.api.newGet(`${this.baseUrl}/creditReport`);
  }

  getSignedDoc(documentId) {
    return this.api.docGet(`/sr/details?documentId=` + documentId + '&verificationDetails=false').pipe(map(res => {
      console.log("api res " + res);
      return res;
    }))
  }


  logout(token, auth) {
    return this.api.postRes('/users/revokeToken', { token: token, auth: auth })
      .pipe(map(res => {
        return res
      }));
  }



  getAppliType() {
    return this.api.postRes('/users/getCustType', { appId: this.applicantId })
      .pipe(map(res => {
        return res;
      }));

  }

  consentformSubmit(data) {
    data.applicantId =  this.getApplicantID();
    data.consent_updated_by = this.getAdminID();
    return this.api.postRes('/users/updateApplicantData', data)
      .pipe(map(res => {
        return res;
      }));
  }


  updateApplicantFinalAnnexureData(data) {
    data.applicantId =  this.getApplicantID();
     return this.api.postRes('/users/updateApplicantFinalAnnexureData', data)
      .pipe(map(res => {
        return res;
      }));
  }
 

  consentyesornoForm(data) {
    return this.api.postRes('/users/ackloanrenewalsms', data)
      .pipe(map(res => {
        return res;
      }));
  }

  getconsentformdata(data) {
    return this.api.postRes('/users/getApplicantLoanData', data)
      .pipe(map(res => {
        return res;
      }));
  }

  getApplicantLoanFinalData(data) {
    return this.api.postRes('/users/getApplicantLoanFinalData', data)
      .pipe(map(res => {
        return res;
      }));
  }

  getcropsdata() {
    return this.api.newGet('/crops/getcropslist');
  }

  getDistrictsAP() {
    return this.api.getComplt('/meebhoomi/landrecords/districts') 
    .pipe(map(admin => {
      return admin;
    }));
  }

  getMandalAP(data){
    return this.api.postRes('/meebhoomi/landrecords/mandals', data)
    .pipe(map(res => {
      return res;
    }));
  }

  getVillageAP(data){
    return this.api.postRes('/meebhoomi/landrecords/villages', data)
    .pipe(map(res => {
      console.log('res service', res);
      return res;
    }));
  }

  getSurveyNumberAP(data){
    return this.api.postRes('/meebhoomi/landrecords/surveynumbers', data)
    .pipe(map(res => {
      return res;
    }));
  }

  getAdangalBySurveyNoAP(data){
    return this.api.postRes(`/meebhoomi/landrecords/landrecord?id=${this.applicantId}`, data) // need to uncomment
   // return this.api.postRes(`/meebhoomi/landrecords/landrecord?id=d25d27eb-da98-4ce6-9948-ec63599f6ed0`, data)
    .pipe(map(res => {
      return res;
    }));
  }

  clickSubmit(data){
    return this.api.postRes('/blg/landSubmitStatus', data)
    .pipe(map(res => {
      return res;
    }));
  }

  getBreStatusAP(value){
   // return this.api.postRes('/land-records/getBreStatus', { appId: this.applicantId }) // need to uncomment
    return this.api.postRes(`/land-records/getBreStatus`,value)
    .pipe(map(res => {
      return res;
    }));
  }

  private handleError(error: HttpErrorResponse) {
    if (error.status === 0) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      console.error(
        `Backend returned code ${error.status}, body was: `, error.error);
    }
    // Return an observable with a user-facing error message.
    return throwError(() => new Error('Something bad happened; please try again later.'));
  }


  getcropsdataDistId(dist) {
    return this.api.getAll(`/crops/getcropslist?distId=${dist.distId}`);
  }

  getCropsListMP(data){
    return this.api.postResMp('/users/getCropList', data)
    .pipe(map(res => {
      return res;
    }));
  }

  getConsentStatus(data) {
    return this.api.postRes('/users/consentStatus', { applicantId: data })
      .pipe(map(res => {
        return res;
      }));
  }

  getOverAllStatus() {
    return this.api.postRes('/users/getOverallStatus', { appId: this.getApplicantID() })
      .pipe(map(res => {
        return res;
      }));
  }

  getCreditData(state,count) {
    return this.api.postRes('/score/getcreditdata', { appId: this.getApplicantID(), state,type:count, env:ENV.serverType})
      .pipe(map(res => {
        return res;
      }));
  }

  getCreditDataAP(type) {
    return this.api.postRes('/score/getcreditdata', { appId: this.getApplicantID(), type: type})
      .pipe(map(res => {
        return res;
      }));
  }


  getDistricts() {

    return this.api.postResMp('/land-records/getDistricts', { })
      .pipe(map(res => {
        return res;
      }));
  }

  getTehsil(id) {

    return this.api.postResMp('/land-records/getTehsils', {distid: id })
      .pipe(map(res => {
        return res;
      }));
  }

  getHalka(id){
    return this.api.postResMp('/land-records/getHalkas', {distid: id.distid, tehid:id.tehid})
    .pipe(map(res => {
      return res;
    }));
  }

  

  getVillage(id){
    return this.api.postResMp('/land-records/getVillages', {distid: id.distid, tehid:id.tehid, halkaid: id.halkaid, })
    .pipe(map(res => {
      return res;
    }));
  }

  getKhasraDetails(lgdCode){
    return this.api.postResMp('/land-records/getKhasraDetails', {lgdCode})
    .pipe(map(res => {
      return res;
    }));
  }

  getKhasraLandDetails(data){
    return this.api.postResMp('/land-records/getKhasraLandDetails', data)
    .pipe(map(res => {
      return res;
    }));
  }

  getKhasraOwnerDetails(data){
    return this.api.postResMp('/land-records/getKhasraOwnerDetails', data)
    .pipe(map(res => {
      return res;
    }));
  }

  getBREStatus(data){
    return this.api.postResMp('/land-records/getBreStatus', data)
    .pipe(map(res => {
      return res;
    }));
  }

  callSatsure(data){
    return this.api.postResMp('/land-records/getSatsureDetails', data)
    .pipe(map(res => {
      return res;
    }));
  }

  getSatsureStatus(){
    return this.api.postResMp('/land-records/satSureStatus', {appId:sessionStorage.getItem('mpApplicantId')})
    .pipe(map(res => {
      return res;
    }));
  }


  getKhasraLandOwnerDetails(data){
    return this.api.postResMp('/land-records/getKhasraLandOwnerDetails', data)
    .pipe(map(res => {
      return res;
    }));
  }

  getCropsList(data){
    return this.api.postResMp('/users/getCropList', data)
    .pipe(map(res => {
      return res;
    }));
  }

  // this.getBaseUrl = `/applicants/${this.applicantId}/assets/bhoomi`;

  consentOtp(custId) {
    return this.api.postRes(`/users/otp`, { custId: custId })
      .pipe(map(resp => {
        console.log("consent otp resp in service " + JSON.stringify(resp));
        return resp;
      }))
  }

  verifyConsentOtp(custId, otp) {
    return this.api.postRes(`/users/verifyotp`, { custId: custId, otp: otp.otpCode })
      .pipe(map(resp => {
        console.log("verify consent otp resp in service " + JSON.stringify(resp));
        return resp;
      }))
  }

  satSureLogin() {
    return this.api.postSatSureLogin(`/webhook/satSureLogin`, {
      "applicantId":sessionStorage.getItem('applicantId')
    }).pipe(map(resp => {
      console.log("Login satsure" + JSON.stringify(resp));
      return resp;
    }))
  }

  satSureFarm(data){
    return this.api.postSatSureFarm(`/webhook/seasonFarm`,{"farm_data":JSON.parse(data),
    "userId":sessionStorage.getItem('satId'),"token":sessionStorage.getItem('satTkn')})
    .pipe(map(resp => {
      console.log("Satsure farm" + JSON.stringify(resp));
      return resp;
    }))
  }

  satSureFarmSave(data){
    return this.api.postRes(`/users/satSure`,{appId:sessionStorage.getItem('applicantId'),farmId:data.farmId,data:data, type:'input'})    
    .pipe(map(resp => {
      console.log("Satsure farm save" + JSON.stringify(resp));
      return resp;
    }))
  }

  // getCropsSatSure(){ //old geomapping report crops
  //   return this.api.satSureGet(`/webhook/masterDataCrop?token=${sessionStorage.getItem('satTkn')}`)
  //   .map(resp => {
  //     console.log("Satsure dropdown list" + JSON.stringify(resp));
  //     return resp;
  //   });
  // }

  getSatsureReportPdf(){
    return this.api.satSurePdfGet(`/users/satSure`);
  }

  sendSmsManual(appId){
    return this.api.postRes(`/users/sendrenewalsms`,{applicantId:appId})    
    .pipe(map(resp => {
      console.log("Sent SMS" + JSON.stringify(resp));
      return resp;
    }))
  }

  deleteBhoomiRecord(i){
    return this.api.postResp('/loansrecord/dellanddetails',{appId : this.getApplicantID(),type:"bhoomi",index:i}).pipe(map(resp => {
      console.log("resp in deleteBhoomiRecord " + JSON.stringify(resp));
      return resp;
    }))
  }

  toggleStatus(appId,type,status){
    return this.api.postRes(`/users/updateconsentStatus`,{applicantId:appId,updatetype:type,data:status})   
    .pipe(map(resp => {
      console.log("Status change" + JSON.stringify(resp));
      return resp;
    }))
  }

  rejectLoan(id){
    return this.api.postRes(`/applicants/updateLoanStatus`,{id,rejectLoan:true,adminId:sessionStorage.getItem('wl-admin-id')})   
    .pipe(map(resp => {
      console.log("Status change" + JSON.stringify(resp));
      return resp;
    }))
  }

  shouldIbeClicked(){
    if(sessionStorage.getItem('DbBEXZNoIA') == "YuPSie"){
      return true;
    }else{
      return false;
    }
  }

  unlockStaleUsers(appId, userId){
    // console.log("appId",appId,"userId",userId);
    return this.api.postRes(`/users/unlockstaleusers`,{applicantId:appId, userId:userId})
    .pipe(map(resp => {
      console.log("Status change" + JSON.stringify(resp));
      return resp;
    }))
  }

}
function throwError(arg0: () => Error) {
  throw new Error('Function not implemented.');
}